import baseUrl from './baseUrl';

export default baseUrl === 'https://giztixgps.giztix.com'
  ? 'https://erpapi.giztix.com/costings'
  : 'https://demoerpapi.giztix.com/costings';
